export enum MessageStatus {
    RECEIVED = 'RECEIVED',
    DELIVERED = 'DELIVERED',
    READ = 'READ',
    PENDING = 'PENDING',
    ERROR = 'ERROR',
}

export enum ConversationStatus {
    READ = 'READ',
    UNREAD = 'UNREAD',
}
